import { Component } from '@angular/core';
import { SelfServiceKwkComponent } from '@zero/self-service/feature-kwk/web';
import { IconComponent } from '@zero/shared/ui-web-design-system';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'self-service-kunden-werben',
  templateUrl: './kunden-werben.component.html',
  imports: [SelfServiceKwkComponent, IconComponent],
})
export class KundenWerbenComponent extends BaseComponent {
  public override showMe = false;
}
